import $ from "jquery";
import Plyr from "plyr";
import Splide from "@splidejs/splide";

/* eslint-disable */
export function bindButtonClick() {
  var isDragging = false;
  $(".pop")
    .mousedown(function () {
      isDragging = false;
    })
    .mousemove(function () {
      isDragging = true;
    })
    .mouseup(function () {
      var wasDragging = isDragging;
      isDragging = false;
      if (!wasDragging) {
        var $type = $(this).attr("data-type");
        var $id = $(this).attr("id");

        $(".popout-box").fadeIn();
        $(".popout-overlay").css("opacity", 100);
        $(".popout-overlay .loading").fadeIn();

        var action = ($(this).hasClass("brochure-slideout") ? "get_brochure_form" : "get_post_content");

        if ($type === "inline") {
          var $targetId = $(this).attr("data-target");
          var $content = $($targetId).html(); // Fetch the HTML content of the target element.

          $(".popout-box .popout-inner .popout-content").html($content); // Insert the content into the popout.

          // Trigger slide-in animation or other actions similar to the AJAX success callback.
          $(".popout-overlay .loading").fadeOut();
          $(".popout-inner").css("right", 0);
        } else {
          $.ajax({
            url: ajax_object.ajax_url,
            data: {
              action: action,
              type: $type,
              id: $id,
            },
            type: "POST",
            success: function (response) {
              $(".popout-box .popout-inner .popout-content").html(response);

              $(".popout-overlay .loading").fadeOut();
              $(".popout-inner").css("right", 0);
              if (($type = "more")) {
                // $(".more-slider").slick({
                //   arrows: false,
                //   speed: 1000,
                //   adaptiveHeight: true,
                //   dots: false,
                //   fade: false,
                //   autoplay: true,
                //   slidesToShow: 2,
                //   swipeToSlide: true,
                //   touchThreshold: 100,
                // });

                new Splide(".splide", {
                  perPage: 2,
                  autoHeight: true,
                  gap: "40px",
                  pagination: false,
                  drag: "free",
                  speed: 1000,
                  flickPower: 400,
                }).mount();
              }
              if (($type = "destinations")) {
                $(".destinations-slider").slick({
                  arrows: false,
                  speed: 600,
                  adaptiveHeight: true,
                  dots: false,
                  fade: false,
                  autoplay: true,
                  slidesToShow: 2,
                });
              }
              if (($type = "photo_collections")) {
                $(".series-slider").slick({
                  arrows: false,
                  speed: 600,
                  adaptiveHeight: true,
                  dots: false,
                  fade: true,
                  autoplay: false,
                  slidesToShow: 1,
                  infinite: true,
                  draggable: false,
                });
                var isPause6, tick6, percentTime6, $bar6, time, $series_slider;

                $series_slider = $(".series-slider");
                time = 2;
                $bar6 = $(".popout-content-photo-collection-slider .progress");
                function startProgressBar6() {
                  resetProgressBar6();
                  percentTime6 = 0;
                  isPause6 = false;
                  tick6 = setInterval(interval6, 30);
                }

                function interval6() {
                  if (isPause6 === false) {
                    percentTime6 += 1 / (time + 0.1);
                    $bar6.css({
                      width: percentTime6 + "%",
                    });
                    if (percentTime6 >= 100) {
                      $series_slider.slick("slickNext");
                      startProgressBar6();
                    }
                  }
                }

                function resetProgressBar6() {
                  $bar6.css({
                    width: 0 + "%",
                  });
                  clearTimeout(tick6);
                }

                startProgressBar6();
                $(
                  ".popout-content .series .series-prev, .popout-content .series .series-next"
                ).click(function () {
                  console.log("true");
                  startProgressBar6();
                });
              }
              if (($type = "video")) {
                const players = Array.from(
                  document.querySelectorAll(".player")
                ).map(
                  (p) =>
                    new Plyr(p, {
                      autoplay: false,
                      controls: ["play-large"],
                    })
                );
              }
            },
          });
        }
      }
    });
}
